import React, { useState } from 'react'

import { Box, TextField } from '@mui/material';
import { Button } from 'reactstrap';

import Editor from 'react-simple-wysiwyg';
import axios from 'axios';
import Swal from 'sweetalert2';
import ReCAPTCHA from "react-google-recaptcha";


//https://nuggettrap.com/api/smartcard/add-news.php

function AddNews() {

    const [newsData, setNewsData] = useState({ subject: '', body: '', date: '', hrf_link: '' });
 const onChange =()=>{
        console.log()
    }
    const saveNews = async () => {
        const resData = await axios.post(`https://ngt.botberries.com/addnews/add`, newsData)
        console.log(newsData)
        setTimeout(() => {
            Swal.fire({
                title: "Insert success!",
                icon: "success",
                draggable: true
            });
            setNewsData({ subject: '', body: '', date: '', hrf_link: '' })
        }, 1000);
    }
    return (
        <div>
            <Box>
                <div>
                    <h5>Add news</h5>
                </div>
                <div className='row'>
                    <div className='col-sm-10'>
                        <TextField id="outlined-basic" label="Subject" variant="outlined"
                            sx={{ '& > :not(style)': { m: 1, width: '90ch' } }}
                            onChange={(e) => { setNewsData((prev) => ({ ...prev, subject: e.target.value })) }}
                            value={newsData.subject} />


                        <TextField id="outlined-basic" label="Date" variant="outlined"
                            sx={{ '& > :not(style)': { m: 1, width: '90ch' } }}
                            onChange={(e) => { setNewsData((prev) => ({ ...prev, date: e.target.value })) }}
                            value={newsData.date} type='date' />


                        <Editor
                            containerProps={{ style: { width: '100%' } }}
                            onChange={(e) => { setNewsData((prev) => ({ ...prev, body: e.target.value })) }}
                            value={newsData.body}
                        />

                        <TextField id="outlined-basic" label="Main Link" variant="outlined"
                            sx={{ '& > :not(style)': { m: 1, width: '90ch' } }}
                            onChange={(e) => { setNewsData((prev) => ({ ...prev, hrf_link: e.target.value })) }}
                            value={newsData.hrf_link} />
                        <div>
                            <ReCAPTCHA
                                sitekey="6Ldp47MsAAAAAJLp3K6lwciznGbRByEu36n062fb"
                                onChange={onChange}
                            />
                            {/* 6LcoPbMsAAAAAG4CYiLePRAwtr_iqKKsXezoLod3 */}
                        </div>
                        <br />
                        <Button color='success' block onClick={saveNews}>Save</Button>
                    </div>
                </div>
            </Box>
        </div>
    )
}

export default AddNews